/**
 * Determines if a color is light or dark.
 * @param color - The color to check (can be any valid CSS color string)
 * @returns true if the color is light, false if it's dark
 */
export function isColorLight(color: string): boolean {
  const tempElement = document.createElement("div");
  tempElement.style.color = color;
  document.body.appendChild(tempElement);
  const computedColor = window.getComputedStyle(tempElement).color;
  document.body.removeChild(tempElement);

  const rgb = computedColor.match(/\d+/g);
  if (!rgb || rgb.length !== 3) {
    console.warn(`Invalid color format: ${color}`);
    return false; // Default to dark if color parsing fails
  }

  const [r, g, b] = rgb.map(Number);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128;
}
